import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
    campoItemCodigoBarras: {
        width: '200px',
    },
});

export default useStyles;
